<template>
  <div v-show="!showInModal" :class="bemBlock" :data-context="context">
    <div v-show="sizes.length > 1" :class="bemElement('sizes')">
      <span
        v-for="size in sizes"
        :key="size.id"
        :class="[
          bemElement('size', {
            'no-sale': isMarketWithoutSale,
            disabled: isDisabled(size),
            selected: isChecked(size),
          }),
        ]"
      >
        <input
          :id="pidsize(size)"
          :ref="`productTileSizeSelectorInput${pidsize(size)}`"
          type="radio"
          :class="bemElement('size-input', { disabled: isDisabled(size) })"
          name="product_size"
          :disabled="isDisabled(size)"
          :value="size.value"
          :data-attr-url="size.url"
          :checked="isChecked(size)"
          @click="handleSizeChange($event, size)"
        />
        <div :class="['size-box', { 'is-strike': isDisabled(size) }]">
          <label :class="bemElement('size-label')" :for="pidsize(size)">
            <s v-if="isDisabled(size)">
              {{ size.displayValue }}
            </s>
            <template v-else>
              {{ size.displayValue }}
            </template>
          </label>
          <div class="strike" />
        </div>
      </span>
    </div>
  </div>
</template>

<script>
import getFrontConfig from '../../common/getFrontConfig';
import bemClassesMixin from '../mixins/bemClassesMixin';
import EventBusConfig from '../config/eventBusConfig';
import initSizeSelector, { ITEMS } from '../vueModalSizeSelector';
import productPropSizesMixin from '../mixins/productPropSizesMixin';
import windowResizeMixin from '../mixins/windowResizeMixin';

const {
  vue: {
    BaseProductTile: {
      context: { plpGrid },
    },
  },
  responsive: { bp_768: bp768 },
  isMarketWithoutSale,
} = getFrontConfig();

export default {
  name: 'BaseProductTileSizeSelector',

  mixins: [bemClassesMixin, productPropSizesMixin, windowResizeMixin],

  props: {
    context: {
      type: String,
      required: false,
      default: plpGrid,
    },
    showInModal: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      // Used only to mark the selected size during request
      temporaryValue: '',
      isMarketWithoutSale,
      dataChangeBreakpoint: bp768,
      modalSizeSelectorOpen: false,
    };
  },

  watch: {
    showInModal(val) {
      this.changeStateModalSizeSelector(val);
    },
  },

  created() {
    initSizeSelector();
  },

  beforeDestroy() {
    if (this.modalSizeSelectorOpen) this.changeStateModalSizeSelector(false);
  },

  methods: {
    eventClosed({ product, currentItem }) {
      if (product?.uuid !== this.product.uuid) return;
      this.$emit('close', currentItem);
    },
    eventSizeChange({ product, size }) {
      if (product?.uuid !== this.product.uuid) return;
      if (!size.selectable) {
        this.$eventBus.$emit(
          EventBusConfig.commands.modalSizeSelector.setProps,
          {
            currentItem: ITEMS.STOCK_ALERT,
            selectedSize: size,
          }
        );
        return;
      }
      // simule event click in original size target (product_tile_quickshop)
      const sizeSelector =
        this.$refs[`productTileSizeSelectorInput${this.pidsize(size)}`];
      sizeSelector?.[0]?.click();
    },
    handleSizeChange(event, size) {
      if (!size.selectable) return;
      this.temporaryValue = size.value;
      setTimeout(() => {
        this.temporaryValue = '';
      }, 5000);
      this.$emit('size:change', size);
    },
    isChecked(size) {
      return this.temporaryValue === size.value;
    },
    isDisabled(size) {
      return !this.isMarketWithoutSale && !size.selectable;
    },
    pidsize(s) {
      return `${this.product.id}${s.value}`;
    },
    changeStateModalSizeSelector(state) {
      this.$eventBus.$emit(
        state
          ? EventBusConfig.commands.modalSizeSelector.createInstance
          : EventBusConfig.commands.modalSizeSelector.removeInstance,
        {
          product: this.product,
          context: this.context,
          selectedSize: this.getLastSelectedSize(),
          currentItem: this.isSelectedSize
            ? ITEMS.ADDED_TO_CART
            : ITEMS.SIZE_SELECTION,
        }
      );
      this.modalSizeSelectorOpen = state;
      if (state) {
        this.$eventBus.$on(
          EventBusConfig.commands.modalSizeSelector.changeSize,
          this.eventSizeChange
        );
        this.$eventBus.$on(
          EventBusConfig.commands.modalSizeSelector.closed,
          this.eventClosed
        );
        this.$eventBus.$on(
          EventBusConfig.commands.modalSizeSelector.closedStockAlert,
          this.eventClosed
        );
      } else {
        this.$eventBus.$off(
          EventBusConfig.commands.modalSizeSelector.changeSize,
          this.eventSizeChange
        );
        this.$eventBus.$off(
          EventBusConfig.commands.modalSizeSelector.closed,
          this.eventClosed
        );
        this.$eventBus.$off(
          EventBusConfig.commands.modalSizeSelector.closedStockAlert,
          this.eventClosed
        );
      }
    },
  },
};
</script>
